import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["title", "body", "dialog"]

  open(event) {
    const button = event.currentTarget
    const title = button.dataset.aiReviewTitle || "AI Review"
    const content = button.dataset.aiReviewContent || ""

    this.titleTarget.textContent = title
    this.bodyTarget.innerHTML = content

    // The controller scope wraps the panel frame + modal shell, so the visible
    // dialog is addressed through its target rather than this.element.
    this.dialogTarget.classList.add("is-open")
    document.body.classList.add("has-modal")
  }

  close() {
    this.dialogTarget.classList.remove("is-open")
    document.body.classList.remove("has-modal")
  }
}
